<div #buttonVejaMais *ngIf="hasNext" class="po-row" style="width:100%; margin-top: 1em; cursor: pointer;">
  <hr class="linhaVerMais" style="max-width: 100%;min-width: auto;width: 45%;"/>

  <div class="np containerVejaMais" style="width: auto;">
    <span class="po-icon po-icon-plus-circle circleVejaMais"></span>
    <span class="verMais">{{ literalsCp?.strVejaMais }}</span>
  </div>

  <hr class="linhaVerMais" style="max-width: 100%;min-width: auto;width: 45%;"/>
</div>
